module.exports = __webpack_public_path__ + "img/pimg8.8f4a00df.png";